module.exports = __webpack_public_path__ + "img/emissionRegisterIcon.e5b103bb.svg";